import {contractForPath,publicResponse} from '../contracts/public-api.mjs';
import axios from 'axios';
import { clientVersion, operationId, recordApiFault, flushApiFaults } from './api-diagnostics.js';
export const apiBaseURL=process.env.VUE_APP_API_BASE_URL||'https://price.adil.com.cn/api/web/v1';
const transport=axios.create({baseURL:apiBaseURL,withCredentials:true,timeout:15000});
function checkBusinessResponse(response){
 if(response.data?.ret&&typeof response.data.ret==='number'){
  const error=new Error(response.data.message||'请求未通过验证');error.response=response;error.config=response.config;return Promise.reject(error);
 }return response;
}
const canRenew=error=>error.response?.headers['x-session-renewable']==='1'&&(error.response.status===403||['SITE_ACCESS_REQUIRED','SESSION_REQUIRED'].includes(error.response.data?.code));
transport.interceptors.response.use(checkBusinessResponse);
let sessionFlight=null,sessionChecked=false;
const wait=ms=>new Promise(resolve=>setTimeout(resolve,ms));
async function establishSession(headers){
 if(!window.crypto?.subtle||typeof TextEncoder==='undefined')throw Object.assign(new Error('当前浏览器无法完成网站验证'),{code:'BROWSER_UNSUPPORTED'});
 const {data:challenge}=await transport.get('/session/challenge',{headers});
 if(!/^[a-f0-9]{48}$/.test(challenge.nonce)||challenge.difficulty!==2)throw new Error('网站验证响应无效');
 const encoder=new TextEncoder(),started=performance.now();let proof=0;
 for(;proof<10000000;proof++){
  // Relative time avoids failures caused by an inaccurate browser wall clock.
  if(performance.now()-started>=110000)throw new Error('网站验证超时，请重试');
  const hash=new Uint8Array(await window.crypto.subtle.digest('SHA-256',encoder.encode(`${challenge.nonce}:${proof}`)));
  if(hash[0]===0)break;if(proof%64===0)await wait(0);
 }
 await transport.post('/session',{proof,...(challenge.challenge?{challenge:challenge.challenge}:{})},{headers});
}
export async function ensureWebSession(force=false,headers={}){
 if(sessionChecked&&!force)return;
 if(!sessionFlight){
  const verify=async()=>{for(let attempt=0;attempt<2;attempt++){
   try{await transport.get('/session',{headers});sessionChecked=true;return;}catch(error){if(!canRenew(error))throw error;}
   try{await establishSession(headers);sessionChecked=true;return;}
   catch(error){if(attempt||!['CHALLENGE_INVALID','CHALLENGE_REPLAYED','SITE_ACCESS_REQUIRED'].includes(error.response?.data?.code))throw error;await wait(100);}
  }};
  sessionFlight=(async()=>{
   const locks=globalThis.navigator?.locks;
   if(locks){const abort=new AbortController(),timer=setTimeout(()=>abort.abort(),45000);try{await locks.request('rc-web-session-v1',{signal:abort.signal},verify);}finally{clearTimeout(timer);}}
   else await verify();
  })().finally(()=>{sessionFlight=null;});
 }return sessionFlight;
}
export const webClient=axios.create({baseURL:apiBaseURL,withCredentials:true,timeout:30000});
webClient.interceptors.request.use(async config=>{
 config._operationId||=operationId();config.headers['X-Rc-Operation-ID']=config._operationId;config.headers['X-Rc-Client-Version']=clientVersion;
 try{await ensureWebSession(false,{'X-Rc-Operation-ID':config._operationId,'X-Rc-Client-Version':clientVersion});}
 catch(error){error._businessConfig=config;throw error;}return config;
});
webClient.interceptors.response.use(checkBusinessResponse);
webClient.interceptors.response.use(response=>{
 const contract=contractForPath(new URL(response.config.url,apiBaseURL+'/').pathname.replace('/api/web/v1',''));
 if(contract){try{response.data=publicResponse(contract,response.data);}catch(error){error.config=response.config;error.response={status:503,data:{code:'RESPONSE_CONTRACT_INVALID',message:error.message}};throw error;}}
 return response;
});
webClient.interceptors.response.use(response=>{void flushApiFaults(transport);return response;},async error=>{
 const config=error._businessConfig||error.config;
 // Auth rejection happens before the business handler. Renew at most once, including writes.
 if(config&&!error._businessConfig&&!config._sessionRetried&&canRenew(error)){
  config._sessionRetried=true;sessionChecked=false;
  try{await ensureWebSession(true,{'X-Rc-Operation-ID':config._operationId,'X-Rc-Client-Version':clientVersion});}
  catch(renewError){recordApiFault(renewError,config);throw renewError;}return webClient(config);
 }
 // Never replay a business submission after an ambiguous network/server failure.
 if(config&&config.method==='get'&&!config._networkRetried&&error.code!=='ERR_CANCELED'&&error.code!=='BROWSER_UNSUPPORTED'&&(!error.response||[502,503,504].includes(error.response.status))){
  config._networkRetried=true;await wait(700);return webClient(config);
 }
 error.message=error.response?.data?.message||error.response?.data?.detail||error.message;
 recordApiFault(error,config);return Promise.reject(error);
});
